webpackJsonp([36733297554888],{

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MarkdownPage = __webpack_require__(46);
	
	var _MarkdownPage2 = _interopRequireDefault(_MarkdownPage);
	
	var _createLink = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * @emails react-core
	 */
	
	var toSectionList = function toSectionList(allMarkdownRemark) {
	  return [{
	    title: '近期文章',
	    items: allMarkdownRemark.edges.map(function (_ref) {
	      var node = _ref.node;
	      return {
	        id: node.fields.slug,
	        title: node.frontmatter.title
	      };
	    }).concat({
	      id: '/blog/all.html',
	      title: '所有文章 ...'
	    })
	  }];
	};
	
	var Blog = function Blog(_ref2) {
	  var data = _ref2.data,
	      location = _ref2.location;
	  return Glamor.createElement(_MarkdownPage2.default, {
	    authors: data.markdownRemark.frontmatter.author,
	    createLink: _createLink.createLinkBlog,
	    date: data.markdownRemark.fields.date,
	    location: location,
	    ogDescription: data.markdownRemark.excerpt,
	    markdownRemark: data.markdownRemark,
	    sectionList: toSectionList(data.allMarkdownRemark),
	    titlePostfix: ' - React Blog'
	  });
	};
	
	Blog.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	// eslint-disable-next-line no-undef
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = Blog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-js-235c753483c3072bc8b5.js